(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-vendors"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.all-vendors').forEach(function (root) {
  var indexLinks = root.querySelectorAll('.all-vendors__index-link[href^="#vendor-letter-"]');
  var headings = root.querySelectorAll('.all-vendors__letter-heading');
  if (!indexLinks.length || !headings.length) return;

  var linkByTarget = {};
  indexLinks.forEach(function (link) {
    linkByTarget[link.getAttribute('href').slice(1)] = link;
  });

  var activeLink = null;
  function setActive(link) {
    if (activeLink === link) return;
    if (activeLink) activeLink.classList.remove('all-vendors__index-link--active');
    if (link) link.classList.add('all-vendors__index-link--active');
    activeLink = link;
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
      if (visible.length) setActive(linkByTarget[visible[0].target.id]);
    }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    headings.forEach(function (h) { observer.observe(h); });
  }

  indexLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      var target = root.querySelector('#' + id);
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
